import * as resources from 'constants/resources'
import type {Resource} from 'constants/resources'

const invalidationMap = {
  [resources.USERS]: [
    resources.REQUEST_APPROVALS,
    resources.REQUEST_DOCUMENTATIONS,
    resources.REQUEST_LEASES,
  ],
  [resources.CONTRACT_TEMPLATES]: [
    resources.REQUEST_APPROVALS,
    resources.REQUEST_DOCUMENTATIONS,
    resources.REQUEST_LEASES,
  ],
  [resources.REQUEST_APPROVALS]: [
    resources.REQUEST_APPROVAL_REVISIONS,
    resources.REQUEST_APPROVAL_CONTRACT_FILES,
  ],
  [resources.REQUEST_APPROVAL_COMMENTS]: [],
  [resources.REQUEST_APPROVAL_REVISIONS]: [],
  [resources.FILES]: [
    resources.REQUEST_APPROVALS,
    resources.REQUEST_APPROVAL_CONTRACT_FILES,
    resources.REQUEST_DOCUMENTATIONS,
    resources.REQUEST_DOCUMENTATION_CONTRACT_FILES,
    resources.REQUEST_LEASES,
    resources.REQUEST_LEASE_CONTRACT_FILES,
  ],
  [resources.REQUEST_APPROVAL_CONTRACT_FILES]: [],
  [resources.REQUEST_DOCUMENTATIONS]: [
    resources.REQUEST_DOCUMENTATION_REVISIONS,
    resources.REQUEST_DOCUMENTATION_CONTRACT_FILES,
  ],
  [resources.REQUEST_DOCUMENTATION_REVISIONS]: [],
  [resources.OPPORTUNITIES]: [],
  [resources.REQUEST_DOCUMENTATION_COMMENTS]: [],
  [resources.REQUEST_DOCUMENTATION_CONTRACT_FILES]: [],
  [resources.REQUEST_LEASES]: [
    resources.REQUEST_LEASE_REVISIONS,
    resources.REQUEST_LEASE_CONTRACT_FILES,
  ],
  [resources.REQUEST_LEASE_COMMENTS]: [],
  [resources.REQUEST_LEASE_REVISIONS]: [],
  [resources.REQUEST_LEASE_CONTRACTS]: [],
  [resources.REQUEST_LEASE_CONTRACT_FILES]: [],
} as const satisfies {[r in Resource]: Resource[]}

export default invalidationMap
